exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-show-products{background:#252642;padding:12px;color:#fff;font-size:15px;text-transform:uppercase;font-weight:600;width:100%;margin-top:12px}.btn-show-products:hover{background-color:#2978db;border-style:dashed;border-color:#2978db}.custom-alert-title{color:#595959!important;text-decoration:underline!important;-webkit-text-decoration-color:#00afef!important;text-decoration-color:#00afef!important}.custom-alert-confirm:hover{background-color:#2978db!important}", ""]);

// exports
